if (document.querySelector(".testimonial-with-slider-list")) {
    var allSlides = document.querySelectorAll(".glide");
    var allSlidesArray = Array.prototype.slice.call(allSlides);

    allSlidesArray.forEach((slide) => {
        const glide = new Glide(slide, {
            type: "carousel",
            perView: 1, // Display 1 slide per view
            focusAt: 0, // Focus on the first slide
            perTouch: 1,
            autoplay: false,
            accessibility: true,
            startAt: 0,
            rewind: true,
            draggable: true,
            swipeThreshold: 80,
            dragThreshold: 120,
            classes: {
                disabledArrow: "glide__arrow--disabled",
            },
            peek: {
                before: 0,
                after: 0,
            },
            perSwipe: "|",
        });

        const totalSlides = slide.querySelectorAll('.glide__slide').length;

        if (totalSlides > 1) {
            glide.mount();

            // Update progress bar function
            function updateProgress(currentIndex) {
                const progressPercentage = ((currentIndex + 1) / totalSlides) * 100;
                slide.querySelector('.stepper-progress').style.width = progressPercentage + '%';
            }

            glide.on('move.after', function () {
                updateProgress(glide.index);
            });

            // Initialize progress bar
            updateProgress(glide.index);
        } else {
            // Hide progress bar if only one slide
            const progressBar = slide.querySelector('.stepper-container');
            if (progressBar) {
                progressBar.style.display = 'none';
            }
            const glide_controls_div = slide.querySelector('.glide__controls');
            if(glide_controls_div){
                glide_controls_div.style.display = "none";
            }
        }
    });
}
